import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import FlightRequestDetails from '../common/flight/flight-request-details';
import FlightRequestChips from '../common/flight/flight-request-chips';
import RequestPreview from '../common/request/request-preview';
import RequestDetailsSkeleton from '../common/skeleton/request-details-skeleton';
import RequestInfoSkeleton from '../common/skeleton/request-info-skeleton';
import OfferInfo from '../common/offer-info';
import { Panel, PanelHeader, PanelContent } from '../common/panel';

import { renderAttachment } from '../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const FlightOffer = () => {
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState({
        skeleton: true,
        backdrop: false
    });
    const [flightOffer, serFlightOffer] = useState(null);
    const [, setError] = useState(null);
    const { id } = useParams();
    let history = useHistory();

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };

    useEffect(() => {
        axios.get(`/api/flightoffer/${id}`, { headers: headers })
            .then(res => {
                serFlightOffer(res.data);
                setTimeout(() => setLoading({ ...loading, skeleton: false }), 500);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [])

    const deleteOffer = () => {
        setLoading({ ...loading, backdrop: true });
        axios.delete(`/api/flightoffer/${id}`, { headers: headers })
            .then(res => {
                setTimeout(() => history.push(`/request/${flightOffer.reservationRequestResource.id}/flight`), 500);

            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }

    return (
        <>
            {
                loading.backdrop ?
                    <Backdrop className="backdrop" open={loading.backdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    :
                    null
            }
            <Grid container spacing={3}>
                <Grid
                    container item xs={12} md={12} lg={9}
                >
                    <Panel>
                        <PanelHeader>Request Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                flightOffer ?
                                    <>
                                        <RequestPreview
                                            label={"Flight"}
                                            keyword={"Cities"}
                                            reservationRequest={flightOffer.reservationRequestResource}
                                            Details={
                                                <FlightRequestDetails
                                                    flightResources={flightOffer.reservationRequestResource.reservationRequestFlightResources}
                                                />
                                            }
                                            Chips={
                                                <FlightRequestChips
                                                    variant={"default"}
                                                    flightResources={flightOffer.reservationRequestResource.reservationRequestFlightResources}
                                                />
                                            }
                                        />
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>Offer Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                flightOffer ?
                                    <>
                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Flight Type:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {flightOffer.flightTypeName}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Tickets (Price / Ticket):
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Adults {flightOffer.adultsNumber} ({flightOffer.adultPrice} L.E.) <br />
                                                    {flightOffer.childrenNumber ?
                                                        <>{`Childs ${flightOffer.childrenNumber} (${flightOffer.childPrice} L.E.)`} <br /></> : null}
                                                    {flightOffer.infantsNumber ?
                                                        `Infants ${flightOffer.infantsNumber} (${flightOffer.infantPrice} L.E.)` : null}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Flights:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                {
                                                    flightOffer.reservationSupplierFlightOfferDetailResources.map((flight, index) => (
                                                        <Grid item xs={12} key={index}>
                                                            <Typography variant="subtitle1" gutterBottom>
                                                                <b>Flight {index + 1} Details</b> <br />
                                                                From: {flight.fromCityName} <br />
                                                                To: {flight.toCityName} <br />
                                                                Departure: {new Date(flight.departureDate).toDateString()} <br />
                                                                {flight.returnDate ? <>{`Return Date: ${new Date(flight.returnDate).toDateString()}`} <br /></> : null}
                                                                Airline: {flight.airlineName} ({flight.isDirectFlight ? 'Direct' : 'Indirect'} Flight)<br />
                                                                Flight Cabin: {flight.flightCabinType1} <br />
                                                            </Typography>
                                                        </Grid>
                                                    ))
                                                }
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Issuance Time Limit:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {flightOffer.issuanceTimeLimit}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Payment Policy:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {flightOffer.paymentPolicy}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={12} md={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Cancellation Policy:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {flightOffer.cancellationPolicy}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Changes Policy:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {flightOffer.changesPolicy}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Attachment:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {renderAttachment(flightOffer.attachment)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>
                </Grid>

                <Grid
                    container item xs={12} md={12} lg={3}
                >
                    <div className="side-info">
                        {
                            loading.skeleton ?
                                <RequestInfoSkeleton />
                                :
                                flightOffer ?
                                    <OfferInfo offer={flightOffer} deleteOffer={deleteOffer} />
                                    : null
                        }
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export default FlightOffer;